/**
 * Entry point: wires up TanStack Query + Router, theme + motion config,
 * then mounts the React tree. Included from src/index.html.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { MotionConfig } from "motion/react";
import { ThemeProvider } from "./lib/theme";
import { router } from "./router";
import "./index.css";
import "./i18n";

const queryClient = new QueryClient();

const app = (
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <MotionConfig reducedMotion="user">
          <RouterProvider router={router} />
        </MotionConfig>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>
);

const elem = document.getElementById("root")!;

const root = import.meta.hot
  ? (import.meta.hot.data.root ??= createRoot(elem))
  : createRoot(elem);

root.render(app);
